export default __webpack_public_path__ + "static/media/kanganvalley.fb9005aa.jpg";